import { ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import axios from 'axios';
import MaterialTable from 'material-table';
import { Component } from "react";
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Redirect } from 'react-router-dom';
import { hasPermission } from "../../utils/usePermission";
import CommonToast from "../Toaster/CommonToast";
import { DateTimeFormat } from "./../DateFormat/DateTimeFormat";
import CommonLoader from "./../loaderComponent/CommonLoader";


export default class ExitEmployeeList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      oldEmployeeData: [],
      selectedUser: null,
      viewRedirect: false,
      loading: true,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
    }
  }


  componentDidMount() {
    axios({
      method: 'get',
      url: '/users/notnull',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({
          oldEmployeeData: res.data,
          loading: false
        })
      })
      .catch(err => {
        console.log(err);
        this.setState({
          oldEmployeeData: [],  // Show empty table
          loading: false,       // Stop the loader
        });
      });
  }

  onOldEmployeeView = (oldEmpData) => {
    return (event) => {
      event.preventDefault()
      this.setState({ selectedUser: oldEmpData, viewRedirect: true })
    }
  }

  render() {
    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })
    return (
      <div className="pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          < >
            <div className="col-sm-12">
              {this.state.viewRedirect ? (<Redirect to={{ pathname: '/exit-employee-view', state: { selectedUser: this.state.selectedUser } }}></Redirect>) : (<></>)}
              <Card className="shadow-sm rounded border-0">
                <Card.Header >
                  <div className="panel-title">
                    <strong>Old Employee List</strong>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      columns={[
                        {
                          title: 'EMP ID', field: 'id',
                          cellStyle: { width: 120, minWidth: 120 },
                          headerStyle: { width: 120, minWidth: 120 },
                        },
                        {
                          title: 'Full Name', field: 'fullName',
                          cellStyle: { width: 250, minWidth: 250 },
                          headerStyle: { width: 250, minWidth: 250 },
                        },
                        {
                          title: 'Department', field: 'department.departmentName',
                          cellStyle: { width: 250, minWidth: 250 },
                          headerStyle: { width: 250, minWidth: 250 },
                        },

                        {
                          title: "Job Title",
                          field: "jobs",
                          cellStyle: { width: 250, minWidth: 250 },
                          headerStyle: { width: 250, minWidth: 250 },
                          render: (rowData) => {
                            return rowData?.jobTitle
                          }
                        },
                        { title: 'Mobile', field: 'user_personal_info.mobile' },
                        {
                          title: 'Start Date',
                          field: 'jobs',
                          cellStyle: { width: 250, minWidth: 250 },
                          headerStyle: { width: 250, minWidth: 250 },
                          render: rowData => rowData.jobs.map((job) => DateTimeFormat(job.startDate)).join(" ")
                        },
                        // {
                        //   title: 'OT Status',
                        //   field: 'otStatus',
                        //   render: rowData => {
                        //     return rowData?.user_financial_info ? rowData?.user_financial_info?.otStatus === 'Yes' ? (
                        //       <Badge pill variant="success">Yes</Badge>
                        //     ) : (
                        //       <Badge pill variant="danger">No</Badge>
                        //     ) : null
                        //   }
                        // },
                        // {
                        //   title: 'ESIC Status',
                        //   field: 'esicStatus',
                        //   render: rowData => {
                        //     return rowData?.user_financial_info ? rowData?.user_financial_info?.esicStatus === 'Yes' ? (
                        //       <Badge pill variant="success">Yes</Badge>
                        //     ) : (
                        //       <Badge pill variant="danger">No</Badge>
                        //     ) : null
                        //     // return rowData?.user_financial_info?.esicStatus
                        //   }
                        // },
                        // {
                        //   title: 'OT (Hours)',
                        //   field: 'OtWorkingHours',
                        //   render: rowData => {
                        //     return rowData?.user_financial_info ? (
                        //       <div className="round">
                        //         {rowData.user_financial_info.OtWorkingHours}
                        //       </div>
                        //     ) : null;

                        //   }
                        // },
                        {
                          title: 'End Date', field: 'endDate',
                          cellStyle: { width: 150, minWidth: 150 },
                          headerStyle: { width: 150, minWidth: 150 },
                          render: (rowData) => {
                            return rowData?.user_financial_info ? rowData.endDate ? DateTimeFormat(rowData.endDate) : "N/A" : null
                          }
                        },
                        {
                          title: 'Reason',
                          field: 'remark',
                          render: rowData => (
                            <div
                              style={{
                                color: 'red',
                                fontWeight: 600
                              }}
                            >
                              {rowData.remark || '-'}
                            </div>
                          ),
                          cellStyle: { width: 80, minWidth: 80, textAlign: 'center' },
                          headerStyle: { width: 80, minWidth: 80, textAlign: 'center' },
                        }
                        ,
                        // {
                        //   title: 'Reason',
                        //   field: 'remark',
                        //   cellStyle: { width: 250, minWidth: 250 },
                        //   headerStyle: { width: 250, minWidth: 250 },
                        // },
                        // {
                        //   title: 'Login(Yes/No)',
                        //   field: 'active',
                        //   render: rowData => (
                        //     rowData.active ? (
                        //       <Badge pill variant="success">Yes</Badge>
                        //     ) : (
                        //       <Badge pill variant="danger">No</Badge>
                        //     )
                        //   )
                        // },
                        {
                          title: 'Action',
                          render: rowData => (
                            <>
                              {rowData.id !== JSON.parse(localStorage.getItem('user')).id ? (
                                <>
                                  {hasPermission('M7S2B3') && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>View Old Employee Details</Tooltip>}
                                    >
                                      <Button size="sm" variant="outline-info" className="mr-2 info" onClick={this.onOldEmployeeView(rowData)}><i className="far fa-eye"></i></Button>
                                    </OverlayTrigger>
                                  )}

                                </>
                              ) : (<></>)}
                            </>
                          ),
                          cellStyle: { width: '100px', minWidth: '100px', textAlign: 'center' },
                          headerStyle: { width: '100px', minWidth: '100px', textAlign: 'center' }
                        }
                      ]}
                      data={this.state.oldEmployeeData}
                      options={{
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 30, 50, 75, 100]
                      }}
                      title="Old Employees"
                    />

                  </ThemeProvider>
                </Card.Body>
              </Card>
            </div>
          </>
        </CommonLoader>
      </div >
    )
  }
}
